
































































import Vue from 'vue';
import commonVuex from '../vuex/common';
import { AccountLevel } from '../models/Account';
import commonClient from '../apis';
import moment from 'moment';

export default Vue.extend({
  mixins: [commonVuex],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'right-end',
    },
    popperClass: {
      type: String,
      default: 'account-box',
    },
  },
  data() {
    return {
      moment,
      showBox: false,
      trialEndDay: null,
      isTrial: false,
      defaultAvater: '',
    };
  },
  methods: {
    avatar() {
      if (this.account.avatar) {
        return this.account.avatar.replace('http://', 'https://');
      } else {
        return this.defaultAvater;
      }
    },
    changeAccount() {
      window.location.href = '#/account/manage';
      this.$emit('cancel');
    },
    accountSet() {
      window.open('https://weixin.drip.im/member/profile/info');
      this.$emit('cancel');
    },
    toUpgrade() {
      window.location.href = '#/upgrade/buy';
      this.$emit('cancel');
    },
    getTrial() {
      commonClient.getTime({}).success((r) => {
        const now = moment(moment(r).format('YYYY-MM-DD'));
        const crmCreate = moment(moment(this.account.crmCreate).format('YYYY-MM-DD'));
        const days = moment.duration(now.diff(crmCreate)).asDays();
        if (days > 3) {
          this.isTrial = false;
        } else {
          this.trialEndDay = crmCreate.add(3, 'days').format('YYYY-MM-DD');
          this.isTrial = true;
        }
      });
    },
  },
  watch: {
    show() {
      this.showBox = this.show;
      this.getTrial();
    },
  },
  mounted() {
    this.showBox = this.show;
    this.getTrial();
  },
});
